export const GET_LOAN_CONVERSIONS = 'loan_conversions/GET_LOAN_CONVERSIONS'
export const ADD_LOAN_CONVERSION = 'loan_conversions/ADD_LOAN_CONVERSION'
export const EDIT_LOAN_CONVERSION = 'loan_conversions/EDIT_LOAN_CONVERSION'
export const SUBMIT_LOAN_CONVERSION = 'loan_conversions/SUBMIT_LOAN_CONVERSION'
export const APPROVE_LOAN_CONVERSION = 'loan_conversions/APPROVE_LOAN_CONVERSION'
export const REJECT_LOAN_CONVERSION = 'loan_conversions/REJECT_LOAN_CONVERSION'
export const DELETE_LOAN_CONVERSION = 'loan_conversions/DELETE_LOAN_CONVERSION'
export const START_LOADING_LOAN_CONVERSION = 'loan_conversions/START_LOADING_LOAN_CONVERSION'
export const STOP_LOADING_LOAN_CONVERSION = 'loan_conversions/STOP_LOADING_LOAN_CONVERSION'
